module.exports = __webpack_public_path__ + "img/uk.d721b202.jpg";